import './assets/css/style.css';

import { Route, Routes } from 'react-router-dom';

import { IntlProvider } from 'react-intl';
import React from 'react';
import About from './pages/About';
import Contact from './pages/Contact';
import Home from './pages/Home';
import LanguageContext from './Context/Language';
import Menu from './components/Menu/Menu';
import Realisations from './pages/Realisations';
import ScrollTop from './components/ScrollToTop';
import useLanguage from './hooks/useLanguage';

function App() {
  const { language, getMessagesFromLang, changeLanguage } = useLanguage();

  return (
    // TODO Fix below.
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      <IntlProvider locale={language} messages={getMessagesFromLang(language)}>
        <Menu />
        <ScrollTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/realisations" element={<Realisations />} />
          <Route path="/parler" element={<Contact />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </IntlProvider>
    </LanguageContext.Provider>
  );
}

export default App;
